import { useState } from 'react'
import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import './Layout.css'

const menuItems = [
  { path: '/', icon: 'home', label: 'ポータル' },
  { path: '/patients', icon: 'person', label: '患者カルテ' },
  { path: '/reservations', icon: 'calendar_month', label: '移植予約カレンダー' },
  { path: '/medical-records', icon: 'description', label: '診療記録' },
  { path: '/asd-diaries', icon: 'auto_stories', label: 'ASD菌力UPダイアリー' },
  { path: '/seminars', icon: 'school', label: '勉強会' },
  { path: '/boards/regular-members', icon: 'forum', label: '掲示板（正会員）' },
  { path: '/papers', icon: 'article', label: '論文共有' },
  { path: '/reports', icon: 'bar_chart', label: 'レポート' },
]

const masterMenuItems = [
  { path: '/master/hospitals', icon: 'local_hospital', label: '病院マスター' },
  { path: '/master/doctors', icon: 'medical_services', label: '医師マスター' },
]

export default function Layout() {
  const [menuOpen, setMenuOpen] = useState(true)
  const [masterMenuOpen, setMasterMenuOpen] = useState(false)
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  const isAdmin = user?.role === 'admin' || user?.role === 'office'

  return (
    <div className="aip-layout" data-menu-state={menuOpen ? 'open' : 'closed'}>
      {/* メニュートグルボタン */}
      <button className="aip-side-menu__toggle" onClick={toggleMenu}>
        <span className="material-symbols-outlined">
          {menuOpen ? 'dock_to_right' : 'menu'}
        </span>
      </button>

      {/* モバイル用オーバーレイ */}
      {menuOpen && (
        <div className="aip-side-menu__overlay" onClick={() => setMenuOpen(false)} />
      )}

      {/* サイドメニュー */}
      <aside className={`aip-side-menu ${menuOpen ? 'aip-side-menu--open' : ''}`}>
        <div className="aip-side-menu__header">
          <h2 className="aip-side-menu__title">FMT-Japan</h2>
        </div>

        <div className="aip-side-menu__search">
          <div className="aip-search-bar">
            <span className="material-symbols-outlined aip-search-bar__icon">search</span>
            <input
              className="aip-search-bar__input"
              type="text"
              placeholder="検索"
            />
          </div>
        </div>

        <nav className="aip-side-menu__nav">
          <div className="aip-side-menu__nav-header">メニュー</div>
          <ul className="aip-side-menu__nav-list">
            {menuItems.map((item) => (
              <li key={item.path} className="aip-side-menu__nav-item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `aip-side-menu__nav-link ${isActive ? 'aip-side-menu__nav-link--active' : ''}`
                  }
                  end={item.path === '/'}
                >
                  <span className="material-symbols-outlined aip-side-menu__nav-icon">
                    {item.icon}
                  </span>
                  <span className="aip-side-menu__nav-text">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>

          {/* マスター管理メニュー（管理者・事務局のみ） */}
          {isAdmin && (
            <>
              <div 
                className="aip-side-menu__nav-header aip-side-menu__nav-header--collapsible"
                onClick={() => setMasterMenuOpen(!masterMenuOpen)}
              >
                <span>マスター管理</span>
                <span className="material-symbols-outlined aip-side-menu__nav-header-icon">
                  {masterMenuOpen ? 'expand_less' : 'expand_more'}
                </span>
              </div>
              {masterMenuOpen && (
                <ul className="aip-side-menu__nav-list">
                  {masterMenuItems.map((item) => (
                    <li key={item.path} className="aip-side-menu__nav-item">
                      <NavLink
                        to={item.path}
                        className={({ isActive }) =>
                          `aip-side-menu__nav-link ${isActive ? 'aip-side-menu__nav-link--active' : ''}`
                        }
                      >
                        <span className="material-symbols-outlined aip-side-menu__nav-icon">
                          {item.icon}
                        </span>
                        <span className="aip-side-menu__nav-text">{item.label}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </>
          )}
        </nav>

        <div className="aip-side-menu__profile">
          <div className="aip-side-menu__profile-avatar">
            {user?.lastName?.charAt(0) || '?'}
          </div>
          <div className="aip-side-menu__profile-info">
            <div className="aip-side-menu__profile-name">{user?.displayName}</div>
            <div className="aip-side-menu__profile-role">
              {user?.role === 'admin' && '管理者'}
              {user?.role === 'office' && '事務局'}
              {user?.role === 'doctor' && '医師'}
              {user?.role === 'medical' && '医療機関'}
              {user?.role === 'associate' && '準会員'}
            </div>
            {user?.hospitalName && (
              <div className="aip-side-menu__profile-hospital">{user.hospitalName}</div>
            )}
          </div>
          <button
            className="aip-side-menu__logout"
            onClick={handleLogout}
            title="ログアウト"
          >
            <span className="material-symbols-outlined">logout</span>
          </button>
        </div>
      </aside>

      {/* メインコンテンツ */}
      <main className="aip-main">
        <Outlet />
      </main>
    </div>
  )
}
